// What the scan zone says back after a tag is scanned: which item it was, its
// SKU and how many of it are now on the bill (a repeat scan raises the line's
// quantity rather than adding a line, so the cashier sees "×2 on the bill").
// An item the till holds none of, and so didn't go on the bill, says so
// (Core's "Stock is not available" popup only flashes for a moment).
import { productForCode } from "./markdowns";

export function scanEcho(products, items, code, { allowNegativeStock = false } = {}) {
  const product = productForCode(products, code);
  if (!product) return null;
  const onBill = (items || []).reduce((n, item) => {
    if (item?.productId !== product.mProductId || item?.isReturn) return n;
    const qty = Number(item.weight ?? item.qty);
    return qty > 0 ? n + qty : n;
  }, 0);
  const stock = product.onhandQty == null || product.onhandQty === "" ? NaN : Number(product.onhandQty);
  const noStock = !allowNegativeStock && onBill === 0 && Number.isFinite(stock) && stock <= 0;
  return { name: String(product.name || "").trim() || null, sku: product.value || null, onBill, productId: product.mProductId, noStock };
}

// "3 pieces · 2 lines": the lines part only once the bill has more than one.
export function bagCountLine(pieces, lineCount) {
  return lineCount > 1 ? `${pieces} · ${lineCount} lines` : pieces;
}
